import { Disclosure } from "@headlessui/react";
import { BarsArrowUpIcon, ChevronDownIcon } from "@heroicons/react/24/solid";
import { useRecoilState, useRecoilValue } from "recoil";
import RefreshButton from "../../../components/RefreshButton";
import SearchButton from "../../../components/SearchButton";
import SelectInput from "../../../components/SelectInput";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import { vendorSearchFilter } from "./atoms/atoms";
import { useGetVendorOptions } from "./hooks/useVendorType";

const TableFilters = ({ filter, vendorSearchData, searchClicked }) => {
  const [searchInputsData, setSearchInputsData] =
    useRecoilState(vendorSearchFilter);
  const user = useRecoilValue(accountAtom);

  const opts = useGetVendorOptions();

  return (
    <div className="pr-3 space-y-2 mt-2">
      <div>
        <BarsArrowUpIcon className="h-6 w-6 text-primary mb-1.5" />
        <div className="text-xl font-bold text-primary -mt-9 ml-8">
          Search Section
        </div>
      </div>
      <div className="w-full">
        <div className="mb-3">
          <Disclosure defaultOpen={filter}>
            {({ open }) => (
              <>
                <Disclosure.Button className="sm:px-2 flex justify-between w-full px-4 py-2 text-sm font-medium text-left text-primary bg-gray-100 rounded-t-lg hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                  <span>Vendor Details</span>
                  <ChevronDownIcon
                    className={`${
                      open ? "transform rotate-180" : ""
                    } w-5 h-5 text-gray-500`}
                  />
                </Disclosure.Button>
                <Disclosure.Panel className="bg-gray-100 text-sm text-primary rounded-b-lg">
                  <div className="bg-gray-100  p-3 sm:px-2 md:px-3">
                    <div className="text-xs text-secondary italic font-normal pb-4">
                      <b> Note:</b> All fields are multiple selection.
                    </div>
                    <div className="flex flex-col text-xs gap-x-4 gap-y-2">
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Vendor Name
                        </label>
                        <SelectInput
                          options={opts?.nameOptions}
                          value={
                            searchInputsData.vendorName
                              ? undefined
                              : searchInputsData.vendorName
                          }
                          onChange={(e) => {
                            setSearchInputsData({
                              ...searchInputsData,
                              vendorId: e ? e.value : 0,
                              vendorName: e ? e.label : null,
                            });
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Type
                        </label>
                        <SelectInput
                          options={opts?.vendorTypesOptions}
                          value={
                            searchInputsData.vendorTypeName
                              ? undefined
                              : searchInputsData.vendorTypeName
                          }
                          onChange={(e) => {
                            setSearchInputsData({
                              ...searchInputsData,
                              vendorTypeId: e ? e.value : 0,
                              vendorTypeName: e ? e.label : "",
                            });
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Phone
                        </label>
                        <SelectInput
                          options={opts?.phoneOptions}
                          value={
                            searchInputsData.phone
                              ? undefined
                              : searchInputsData.phone
                          }
                          onChange={(e) => {
                            setSearchInputsData({
                              ...searchInputsData,
                              phone: e ? e.value : "",
                            });
                          }}
                          secondDiv="items-center"
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Physical Street
                        </label>
                        <SelectInput
                          options={opts?.streetOptions}
                          value={
                            searchInputsData.physicalStreet
                              ? undefined
                              : searchInputsData.physicalStreet
                          }
                          onChange={(e) => {
                            setSearchInputsData({
                              ...searchInputsData,
                              physicalStreet: e ? e.value : "",
                            });
                          }}
                          secondDiv="items-center"
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Physical State
                        </label>
                        <SelectInput
                          options={opts?.stateOptions}
                          value={
                            searchInputsData.physicalState
                              ? undefined
                              : searchInputsData.physicalState
                          }
                          onChange={(e) => {
                            setSearchInputsData({
                              ...searchInputsData,
                              physicalState: e ? e.value : "",
                            });
                          }}
                          secondDiv="items-center"
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Inactive Account
                        </label>
                        <SelectInput
                          options={[
                            {
                              label: "True",
                              value: true,
                            },
                            {
                              label: "False",
                              value: false,
                            },
                          ]}
                          value={
                            searchInputsData.inactiveAccount !== null
                              ? undefined
                              : searchInputsData.inactiveAccount
                          }
                          onChange={(e) => {
                            setSearchInputsData({
                              ...searchInputsData,
                              inactiveAccount: e ? e.label : "",
                            });
                          }}
                          secondDiv="items-center"
                        />
                      </div>

                      <div className="flex justify-center items-end gap-x-2 mb-12  lg:ml-4 md:ml-1 rounded-md mt-5">
                        <SearchButton
                          buttonValue="Search"
                          onClick={async () => {
                            await vendorSearchData();
                            searchClicked();
                          }}
                        />
                        <RefreshButton
                          onClick={async () => {
                            setSearchInputsData({
                              vendorId: "",
                              vendorName: "",
                              vendorTypeName: "",
                              vendorTypeId: 0,
                              phone: "",
                              physicalStreet: "",
                              physicalState: "",
                              inactiveAccount: null,
                            });
                            await vendorSearchData();
                            searchClicked();
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        </div>
      </div>
    </div>
  );
};

export default TableFilters;
